import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconShoppingBag, IconMenu2, IconX, IconChevronDown } from '@tabler/icons-react';
import { useSiteContent, useCollectionPages } from '../../context/SiteContentContext';
import { useCart } from '../../context/CartContext';
import './Navbar.css';

export default function Navbar() {
  var location = useLocation();
  var content = useSiteContent();
  var c = content.c;
  var collectionPages = useCollectionPages();
  var cart = useCart();
  var itemCount = cart.itemCount;
  var openDrawer = cart.openDrawer;
  var _menuOpen = useState(false);
  var menuOpen = _menuOpen[0]; var setMenuOpen = _menuOpen[1];
  var _openDropdown = useState(null);
  var openDropdown = _openDropdown[0]; var setOpenDropdown = _openDropdown[1];

  var brandName = c('brand_name', 'Andre M Leather');
  var parts = brandName.split(' ');
  var goldIndex = parts.findIndex(function(p) { return p.length === 1; });

  var navLinkLabels = c('nav_links', 'Shop,About,Care guide,Contact').split(',');
  var navPaths = ['/shop', '/about', '/care-guide', '/contact'];

  function closeMenu() { setMenuOpen(false); setOpenDropdown(null); }

  function toggleMobileDropdown(label) {
    setOpenDropdown(openDropdown === label ? null : label);
  }

  return (
    <nav className="navbar">
      <Link to="/" className="navbar__logo" onClick={closeMenu}>
        {parts.map(function(part, i) {
          return (
            <span key={i}>
              {i > 0 && ' '}
              {i === goldIndex ? <span className="navbar__logo-m">{part}</span> : part}
            </span>
          );
        })}
      </Link>

      <ul className={'navbar__links' + (menuOpen ? ' navbar__links--open' : '')}>
        {navLinkLabels.map(function(label, i) {
          var trimmed = label.trim();
          var isActive = location.pathname === navPaths[i];
          var childPages = collectionPages.byNav(trimmed);
          var hasChildren = childPages.length > 0;

          if (hasChildren) {
            return (
              <li key={i} className="navbar__dropdown-wrap"
                onMouseEnter={function() { setOpenDropdown(trimmed); }}
                onMouseLeave={function() { setOpenDropdown(null); }}
              >
                <span className={'navbar__link' + (isActive ? ' navbar__link--active' : '')}
                  onClick={function() { toggleMobileDropdown(trimmed); }}
                >
                  {trimmed} <IconChevronDown size={10} className="navbar__chevron" />
                </span>

                <div className={'navbar__dropdown' + (openDropdown === trimmed ? ' navbar__dropdown--open' : '')}>
                  <Link to={navPaths[i]} className="navbar__dropdown-item" onClick={closeMenu}>
                    {'All ' + trimmed.toLowerCase()}
                  </Link>
                  {childPages.map(function(pg) {
                    return (
                      <Link key={pg.id} to={'/shop/' + pg.slug} className="navbar__dropdown-item" onClick={closeMenu}>
                        {pg.name}
                      </Link>
                    );
                  })}
                </div>
              </li>
            );
          }

          return (
            <li key={i}>
              <Link
                to={navPaths[i] || '/'}
                className={'navbar__link' + (isActive ? ' navbar__link--active' : '')}
                onClick={closeMenu}
              >
                {trimmed}
              </Link>
            </li>
          );
        })}
      </ul>

      <div className="navbar__right">
        {/* Sign in is hidden for launch; customer accounts come in a later plan. */}
        <button className="navbar__cart" aria-label="Shopping bag" onClick={openDrawer}>
          <IconShoppingBag size={18} />
          {itemCount > 0 && <span className="navbar__cart-badge">{itemCount}</span>}
        </button>
        <button className="navbar__hamburger" aria-label="Menu" onClick={function() { setMenuOpen(!menuOpen); }}>
          {menuOpen ? <IconX size={20} /> : <IconMenu2 size={20} />}
        </button>
      </div>
    </nav>
  );
}